
export function updateLegalRepresentative(legalRepresentativeRepository, legalRepresentative, legalRepresentativeId) {
  return legalRepresentativeRepository.update(legalRepresentative, legalRepresentativeId);
}
